import type { SVGProps } from "react";
import * as React from "react";

const SvgGitBranch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 3a1 1 0 0 0-2 0zM5 3v12h2V3zm15 3a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2h-2a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2V2a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zM8 18a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2H2a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2v-2a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zm11-7a8 8 0 0 1-2.343 5.657l1.414 1.414A10 10 0 0 0 19 9zm-2.343 5.657A8 8 0 0 1 9 17v2a10 10 0 0 0 7.071-2.929z"
    />
  </svg>
);
export default SvgGitBranch;
